import { HeroTitle } from '@components/hero-title'
import { MotionValue } from 'framer-motion'
import React, { FC, useEffect, useState } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'
import { Photos } from './photos'

type IntroProps = HowItWorksSingleton['fields']['hero'] & {
  scrollY: MotionValue<number>
}

export const Intro: FC<IntroProps> = ({ heroDescription, heroTitle, images, scrollY }) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <>
      <HeroTitle title={heroTitle} description={heroDescription} visible={isMounted} />
      <Photos images={images} status={isMounted ? 'visible' : 'hidden'} scrollY={scrollY} />
    </>
  )
}
